import { createTheme, type CSSVariablesResolver, type MantineColorsTuple } from "@mantine/core";
import { fonts, palette, radius, scales } from "./tokens";

const tuple = (s: readonly string[]) => [...s] as unknown as MantineColorsTuple;

export const mantineTheme = createTheme({
  primaryColor: "lime",
  primaryShade: 5,
  autoContrast: true,
  luminanceThreshold: 0.45,
  colors: {
    lime: tuple(scales.lime),
    violet: tuple(scales.violet),
    ink: tuple(scales.ink),
    sand: tuple(scales.sand),
  },
  black: palette.ink,
  fontFamily: fonts.body,
  fontFamilyMonospace: fonts.mono,
  headings: { fontFamily: fonts.heading, fontWeight: "750" },
  defaultRadius: "md",
  radius,
  cursorType: "pointer",
  components: {
    Button: { defaultProps: { fw: 650 } },
    Card: { defaultProps: { radius: "lg", withBorder: true, padding: "lg" } },
    Paper: { defaultProps: { radius: "lg" } },
    Badge: { defaultProps: { radius: "sm", fw: 600 } },
    Tooltip: { defaultProps: { withArrow: true, color: "ink.8" } },
  },
  other: { palette },
});

export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {
    "--pd-ink": palette.ink,
    "--pd-ink-raised": palette.inkRaised,
    "--pd-ink-border": palette.inkBorder,
    "--pd-ink-muted": palette.inkMuted,
    "--pd-cream": palette.cream,
    "--pd-sand": palette.sand,
    "--pd-lime": palette.lime,
    "--pd-violet": palette.violet,
    "--pd-green": palette.green,
    "--pd-amber": palette.amber,
    "--pd-protein": palette.protein,
    "--pd-carbs": palette.carbs,
    "--pd-fat": palette.fat,
  },
  light: {
    "--mantine-color-body": palette.cream,
    "--mantine-color-text": palette.text,
    "--mantine-color-dimmed": palette.textMuted,
    "--mantine-color-default-border": palette.sand,
  },
  dark: {},
});
